export default "__VITE_ASSET__BJjwcuPN__"